<template>
  <AppDrawer v-model="showModal" dialog-titel="Sortering">
    <template #header>
      <div class="flex gap-8 flex-col">
        <h5 class="heading-xs">{{ title }}</h5>
        <p>{{ description }}</p>
      </div>
    </template>

    <p class="heading-xxs">Kategorier</p>
    <p>Välj en eller flera</p>
    <div class="flex gap-8 flex-wrap w-fit pt-8">
      <FilterInputButton
        v-for="(option, idx) in SortModes"
        :key="idx"
        root-extra-classes="col-start-auto"
        type="checkbox"
        :checked="filterStore.sortMode === option"
        @on-clicked="
          () => {
            filterStore.sortMode = option;
            nextTick(() => {
              showModal = false;
            });
          }
        "
      >
        <template #label>{{ option }}</template>
      </FilterInputButton>
    </div>
  </AppDrawer>
</template>

<script setup lang="ts">
import { SortModes } from '~/models/Filter.models';
const filterStore = useFilterStore();
const showModal = defineModel<boolean>();

withDefaults(
  defineProps<{
    title: string;
    description: string;
  }>(),
  {},
);
</script>
